module.exports = __webpack_public_path__ + "img/787628d.jpg";